export default __webpack_public_path__ + "352dfd0d8aeefdae202b86729fb923ab.svg";